// Material UI components
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { Box, Theme, Typography } from "@mui/material";

// Components
import Breadcrumbs from "components/PaceLabsDashboard/Breadcrumbs";
import LeadershipProfile from "components/PaceLabsDashboard/LeadershipProfile/LeadershipProfile";
import YourProfile from "components/PaceLabsDashboard/YourProfile/YourProfile";
import PaceLabsInsights from "components/PaceLabsInsights";
import NavButton from "components/HeaderNavigation/NavButton";
import { Header, HeaderInner } from "components/Layout/LayoutContent";

// Hooks
import useMyExperience from "pages/MyExperience/useMyExperience";

// Enums
import { urlPaths } from "enums/urlPaths";
import { useIntl } from "react-intl";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        dashboardContent: {
            display: "flex",
            marginTop: theme.spacing(4),
        },
        leftSideContainer: {
            width: "65%",
        },
        rightSideContainer: {
            width: "35%",
            marginLeft: theme.spacing(2),
        },
    })
);

const MyExperience = () => {
    const classes = styles();
    const intl = useIntl();

    const {
        person_id,
        pathname,
        steps,
        chartName,
        stepSelected,
        chartSelected,
        rootStepPosition,
        transitionTo,
        shouldShowAlertMessage,
        hasCompletedTheAssessment,
        onClickNavigateMainBreadcrumb,
        navigateToMyDashboard,
    } = useMyExperience();

    return (
        <Box>
            <Header backgroundColor="primary">
                <HeaderInner>
                    <Typography variant="h5" fontWeight={600}>
                        {intl.formatMessage({ id: "pace.myExperience.title" })}
                    </Typography>
                    <NavButton
                        variant="outlined"
                        translationId="pace.myExperience.navButton.label"
                        showBackArrow={false}
                        icon={null}
                        onClick={navigateToMyDashboard}
                    />
                </HeaderInner>
            </Header>

            <Box p={2}>
                <Typography variant="subtitle1" color="secondary.main" mb={2}>
                    {intl.formatMessage({ id: "pace.myExperience.description" })}
                </Typography>
                <Breadcrumbs steps={steps} onNavigate={onClickNavigateMainBreadcrumb} />

                <Box className={classes.dashboardContent}>
                    {/* Left content */}
                    <Box className={classes.leftSideContainer}>
                        {pathname.includes(urlPaths.PaceLabsInsights) ? (
                            <Box width="100%">
                                <PaceLabsInsights
                                    chartName={chartName}
                                    stepSelected={stepSelected}
                                    chartSelected={chartSelected}
                                    rootStepPosition={rootStepPosition}
                                    transitionTo={transitionTo}
                                    hasCompletedTheAssessment={hasCompletedTheAssessment}
                                />
                            </Box>
                        ) : (
                            <LeadershipProfile personId={person_id} shouldShowAlertMessage={shouldShowAlertMessage} />
                        )}
                    </Box>

                    {/* Right content */}
                    <Box className={classes.rightSideContainer}>
                        <YourProfile
                            personId={person_id}
                            title={intl.formatMessage({ id: "pace.myDashboard.workHistory.title" })}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default MyExperience;
